export class CourseVideosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getCourseVideos(params) {
    return this.instance.get('/v1/course-videos', {
      params: params || null,
    });
  }

  getCourseVideo(id) {
    return this.instance.get(`/v1/course-videos/${id}`);
  }

  insertCourseVideo(data) {
    return this.instance.post('/v1/course-videos', data, {
      timeout: 120000,
    });
  }

  editCourseVideo(data, id) {
    return this.instance.put(`/v1/course-videos/${id}`, data, {
      timeout: 120000,
    });
  }

  deleteCourseVideo(id) {
    return this.instance.delete(`/v1/course-videos/${id}`);
  }
}

export default (...params) => new CourseVideosFactory(...params);

